<template>
    <CInput
        :isValid="isValid"
        :value.sync="password"
        :type="toggleInputType()"
        :label="label"
        :horizontal="horizontal"
        :placeholder="placeholder"
        :invalidFeedback="invalidFeedback"
        :disabled="disabled"
        class="input-password"
        :addInputClasses="['input-password__input']"
    >
        <template #append>
            <CButton class="input-password__button bg-gray-200" @click="togglePassword()">
                <CIcon size="lg" :content="$options.icons.eye" />
            </CButton>
        </template>
    </CInput>
</template>

<script>
import { eye }  from '~/assets/icons/js/eye';
export default {
    name: "PasswordInputComponent",

    icons:{
        eye
    },
    props: {
        isValid: {
            type: Boolean,
            default: null
        },
        label: {
            type:String,
            default: null
        },
        value:{
            default:null
        },
        horizontal:{
            default: false
        },
        placeholder:{
            default:null
        },
        invalidFeedback:{
            default:undefined
        },
        disabled:{
            default:false
        },
        under:{
            default:false
        }
        

    },
    data(){
        return{
            password:null,
            hidden_password:true
        }
    },
    watch:{
        password(newValue){
            this.$emit('update:value',newValue);
        }
    },
    methods:{
        toggleInputType(){
            let type = 'password';
            if(!this.hidden_password){
                type="text";
            }
            return type
        },
        togglePassword(){
            this.hidden_password = !this.hidden_password;
        }
    },
    async mounted(){
        // this.password = this.value;
    }

}
</script>
<style lang="scss">

    .input-password{
        
        & .input-password__input{
            height: auto !important;
        }

        & .input-password__icon{
            margin: auto 0.5rem;
        }
        & .input-password__icon--under{
                position: absolute;
                right: 1%;
                top: 15%;
                z-index: 1060;
            }
    }

</style>